/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckoutFullfillmentStockings200ResponseAllOfData } from './GetCheckoutFullfillmentStockings200ResponseAllOfData';
import {
    GetCheckoutFullfillmentStockings200ResponseAllOfDataFromJSON,
    GetCheckoutFullfillmentStockings200ResponseAllOfDataFromJSONTyped,
    GetCheckoutFullfillmentStockings200ResponseAllOfDataToJSON,
} from './GetCheckoutFullfillmentStockings200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckoutFullfillmentStockings200ResponseAllOf
 */
export interface GetCheckoutFullfillmentStockings200ResponseAllOf {
    /**
     * 
     * @type {GetCheckoutFullfillmentStockings200ResponseAllOfData}
     * @memberof GetCheckoutFullfillmentStockings200ResponseAllOf
     */
    data: GetCheckoutFullfillmentStockings200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetCheckoutFullfillmentStockings200ResponseAllOf interface.
 */
export function instanceOfGetCheckoutFullfillmentStockings200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCheckoutFullfillmentStockings200ResponseAllOfFromJSON(json: any): GetCheckoutFullfillmentStockings200ResponseAllOf {
    return GetCheckoutFullfillmentStockings200ResponseAllOfFromJSONTyped(json, false);
}

export function GetCheckoutFullfillmentStockings200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckoutFullfillmentStockings200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckoutFullfillmentStockings200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetCheckoutFullfillmentStockings200ResponseAllOfToJSON(value?: GetCheckoutFullfillmentStockings200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckoutFullfillmentStockings200ResponseAllOfDataToJSON(value.data),
    };
}

